"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeadersInfo = getHeadersInfo;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash.find"));

var _children = require("../helpers/children");

var _header = require("./header");

var _Row = _interopRequireDefault(require("./Row"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var UP = 'sortup';
var DOWN = 'sortdown';
var DEFAULT = 'sortable';

function getInitialSortingState(headers) {
  var states = [];
  headers.map(function (header, index) {
    if (!header.props.sortable) {
      states.push({
        currentIndex: 0,
        sortingDirection: false
      });
      return;
    }

    var _header$props = header.props,
        sortSequence = _header$props.sortSequence,
        defaultSortDirection = _header$props.defaultSortDirection;
    var defaultIndex = sortSequence.indexOf(defaultSortDirection);
    states.push({
      currentIndex: defaultIndex,
      sortingDirection: defaultSortDirection
    });
  });
  return states;
}
/**
 * Returns the first Sortable Header from the given array
 * @param { Array } headersArr
 * @returns the first React Element which has `props.sortable === true`
 */


function findSortableHeader(headersArr) {
  return (0, _lodash.default)(headersArr, function (header) {
    return header.props.sortable === true;
  });
}

function getHeadersInfo(children) {
  var hasSortableHeaders = false;
  var rows = (0, _children.getDirectChildrenOfType)(children, _Row.default);
  var headers = rows.reduce(function (childrenArr, row) {
    var childHeaders = (0, _children.getDirectChildrenOfType)(row.props.children, _header.Header);
    if (!childHeaders) return childrenArr;

    if (!hasSortableHeaders) {
      hasSortableHeaders = !!findSortableHeader(childHeaders);
    }

    return [].concat(_toConsumableArray(childrenArr), _toConsumableArray(childHeaders));
  }, []);
  return {
    headers: headers,
    hasSortableHeaders: hasSortableHeaders
  };
}

var SortableColumns =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SortableColumns, _React$PureComponent);

  function SortableColumns(props) {
    var _this;

    _classCallCheck(this, SortableColumns);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SortableColumns).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateSortDirectionByIndex", function (colIndex) {
      var sorting = _this.state.sorting;
      var headers = _this.props.headers;
      var header = headers[colIndex];

      var nextState = _this.resetSortDirections(sorting, colIndex, headers);

      var nextColState = _this.getNextSortState(nextState[colIndex], header.props.sortSequence);

      nextState[colIndex] = _objectSpread({}, sorting[colIndex]);

      _this.setState(nextState, function () {
        var onSortDirectionChange = header.props.onSortDirectionChange;
        onSortDirectionChange && onSortDirectionChange(nextColState);
      });
    });

    var _sorting = getInitialSortingState(props.headers);

    _this.state = {
      sorting: _sorting
    };
    return _this;
  }

  _createClass(SortableColumns, [{
    key: "resetSortDirections",
    value: function resetSortDirections(sorting, colIndex, headers) {
      var len = Object.values(sorting).length - 1;

      for (var i = len; i >= 0; i--) {
        sorting[i].currentIndex = i === colIndex ? sorting[i].currentIndex : -1;
        sorting[i].sortingDirection = DEFAULT;
      }

      return sorting;
    }
  }, {
    key: "getNextSortState",
    value: function getNextSortState(headerState, sortSequence) {
      ++headerState.currentIndex; // If first sortSequence is assorted on first click jumps to the next sortSequence

      if (headerState.currentIndex === 0 && sortSequence[0] === 'sortable') ++headerState.currentIndex;
      var sortingDirection = sortSequence[headerState.currentIndex % sortSequence.length];
      headerState.sortingDirection = sortingDirection;
      return sortingDirection;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        sorting: _objectSpread({}, this.state.sorting),
        updateSortDirectionByIndex: this.updateSortDirectionByIndex
      });
    }
  }]);

  return SortableColumns;
}(_react.default.PureComponent);

SortableColumns.SORT_DIRECTION = {
  UP: UP,
  DOWN: DOWN,
  DEFAULT: DEFAULT
};
SortableColumns.propTypes = {
  children: _propTypes.func.isRequired,
  headers: _propTypes.array.isRequired
};
var _default = SortableColumns;
exports.default = _default;
SortableColumns.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "resetSortDirections",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "sorting",
      "type": null
    }, {
      "name": "colIndex",
      "type": null
    }, {
      "name": "headers",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getNextSortState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "headerState",
      "type": null
    }, {
      "name": "sortSequence",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateSortDirectionByIndex",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "colIndex",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "SortableColumns",
  "props": {
    "children": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": ""
    },
    "headers": {
      "type": {
        "name": "array"
      },
      "required": true,
      "description": ""
    }
  }
};